export default __webpack_public_path__ + "static/media/bigWheel.a3631ee7.png";